export const ROUTE_NAMES = {
  STARTUP: 'startup',
  HOME: 'home',
  RETURNS: 'returns',
  RETURN_ACCOUNTING: 'returnAccounting',
  RETURN_TIMELINE: 'returnTimeline',
  RETURN_RAW: 'returnRaw',
  RETURN_SETTINGS: 'returnSettings',
  RETURN_FORMATTED: 'returnFormatted',
  RETURN_LEDGER: 'returnLedger',
  RETURN_LOGS: 'returnLogs',
  RETURN_WORKFLOW_LOGS: 'returnWorkflowLogs',
  ORDER_ACCOUNTING: 'orderAccounting',
  ORDER_RAW: 'orderRaw',
  ORDER_FORMATTED: 'orderFormatted',
  ORDER_WORKFLOW_LOGS: 'orderWorkflowLogs',
  WORKFLOW_LOGS: 'workflowLogs',
  LOOP_ASSISTANT: 'loopAssistant',
  LOOP_ASSISTANT_SESSION: 'loopAssistantSession',
  KNOWLEDGE_SNIPPETS: 'knowledgeSnippets',
  KNOWLEDGE_SNIPPET_CREATE: 'knowledgeSnippetCreate',
  KNOWLEDGE_SNIPPET_EDIT: 'knowledgeSnippetEdit',
  BACKGROUND_AGENTS_FLEET: 'backgroundAgentsFleet',
  EXPERIMENTS: 'experiments',
  EXPERIMENT_CREATE: 'experimentCreate',
  EXPERIMENT_DETAIL: 'experimentDetail',
  SHIPPING: 'Shipping',
  SENDCLOUD: 'sendcloud',
  SHOP_HOME: 'shopHome',
  SHOP_PLANS: 'shopPlans',
  SHOP_SETTINGS: 'shopSettings',
  SHOP_LOCATIONS: 'shopLocations',
  SHOP_FEATURES: 'shopFeatures',
  SHOP_TAXONOMY: 'shopNewVariantTaxonomy',
  SHOP_USERS: 'shopUsers',
  SHOP_SHIPPING: 'shopShipping',
  SHOP_REPORTS: 'shopReports',
  SHOP_UPDATES: 'shopUpdates',
  SHOP_UPDATE_LOGS: 'updateLogs',
  SHOP_CONSUMER_PAID: 'shopConsumerPaid',
  SHOP_SYNC: 'shopSync',
  SHOP_API_KEYS: 'shopApiKeys',
  SHOP_WEBHOOKS: 'shopWebhooks',
  SHOP_SHIPBOB: 'shopShipBob',
  SHOP_BULK_RETURN_ACTIONS: 'shopBulkReturnActions',
  SHOP_CONCIERGE_RECIPE: 'shopConciergeRecipe',
  SHOP_BENEFIT_RULES_OVERRIDE: 'shopBenefitRulesOverride',
  SHOP_CSP_DOMAINS: 'shopCspDomains',
  SHOP_SETTINGS_AUDIT: 'shopSettingsAudit',
  SHOP_GRAPHIQL: 'shopGraphiql',
  SHOP_OBSERVABILITY: 'shopObservability',
  SHOP_OBSERVABILITY_REQUEST: 'shopObservabilityRequest',
  EARLY_ACCESS: 'earlyAccess',
  EARLY_ACCESS_BETA_FEATURE_NEW: 'earlyAccessBetaFeatureNew',
  EARLY_ACCESS_BETA_FEATURE_EDIT: 'earlyAccessBetaFeatureEdit',
  ORGANIZATIONS: 'organizations',
  ORGANIZATION: 'organization',
  ORGANIZATION_USERS: 'organizationUsers',
  CHECKOUT_PLUS_BILLING: 'checkoutPlusBilling',
  SHOP_APP_EMBEDS: 'shopAppEmbeds',
  SHOP_WEB_PIXEL: 'shopWebPixel',
  SHOP_BACKGROUND_AGENTS: 'shopBackgroundAgents',
  GDPR: 'redactGDPRData',
  DEMO_SHOPS: 'demoShops',
  DEMO_SHOPS_HISTORY: 'demoShopsHistory',
  MERCHANT_NOTIFICATIONS: 'merchantNotifications',
  MERCHANT_NOTIFICATION_CREATE: 'merchantNotificationCreate',
  MERCHANT_NOTIFICATION_EDIT: 'merchantNotificationEdit',
  BLUECHERRY_REMEDIATION: 'blucherryRemediation',
  AUDIT_NON_USD_FEES: 'auditNonUsdFees',
  LOOP_ANYWHERE_SETUP: 'loopAnywhereSetup',
  BULK_DESTINATION_ADDRESS_UPDATE: 'bulkDestinationAddressUpdate',
} as const;
